<div class="flex flex-col gap-2.5">
  @for (entity of nItems; track $index) {

  <div class="grid min-h-8 grid-cols-[30px_1fr_25px] gap-2 items-center">
    <div
      class="w-[30px] animate-pulse bg-[#DDDEE0] h-[30px] max-sm:w-[12px] max-sm:h-[12px] cursor-pointer border border-grey-7 border-solid rounded-full object-contain"
    ></div>

    <div class="flex flex-col gap-2">
      <div class="animate-pulse bg-[#DDDEE0] w-32 h-4"></div>

      <div class="animate-pulse bg-[#DDDEE0] w-20 h-3 max-sm:h-[10px]"></div>
    </div>

    <div class="animate-pulse bg-[#DDDEE0] w-5 h-5 rounded-full"></div>
  </div>
  }
</div>
